<button
  class="icon-and-text"
  *ngIf="viewAllState === viewRef.ICON_AND_TEXT"
  (click)="onClick()"
>
  <span>{{ 'i18n.menuProfitPro.addIngredient.viewAll' | translate }}</span>
  <ion-icon name="caret-forward-outline"></ion-icon>
</button>
<div class="icon-and-text" *ngIf="viewAllState === viewRef.ICON_ONLY_FILLED">
  <ion-icon name="caret-forward-outline"></ion-icon>
</div>
<div class="icon-and-text" *ngIf="viewAllState === viewRef.ICON_ONLY_OUTLINE">
  <ion-icon name="chevron-forward-outline"></ion-icon>
</div>
<ion-button
  class="icon-and-text usf-green-link-button"
  *ngIf="viewAllState === viewRef.TEXT_ONLY"
>
  <span>{{ 'i18n.menuProfitPro.addIngredient.viewAll' | translate }}</span>
</ion-button>
